const concernSubstanceListsDescriptor = Object.freeze({
    type: 'concern-substance-lists',
    version: 1,
    defaultTitleKey: 'Page(ReceivedRequest):Component(StepItem):concern-elements-label',
    fallbackTitle: 'Concern elements',
    capabilities: {
        repeatable: false,
        supportedModes: ['single'],
        supportsReadOnly: false,
        contributesToReply: true,
    },
    dataScopes: {
        reads: [
            'request.legislations',
            'product.card',
            'product.concern-substances',
        ],
        writes: [
            'product.card',
            'product.concern-substances',
        ],
    },
    effects: {
        publishes: [
            'product.card.changed',
            'product.concern-substances.changed',
        ],
        observes: [],
    },
    settingsSchema: {
        type: 'object',
        additionalProperties: false,
        properties: {
            showQuestions: { type: 'boolean', default: true },
            showInstruction: { type: 'boolean', default: false },
            showSubstanceListInstruction: { type: 'boolean', default: true },
            showNoSinglePartsCheckbox: { type: 'boolean', default: true },
            showInformationOwnerSettings: { type: 'boolean', default: false },
            companyHasInformation: { type: 'boolean', default: true },
            autoExpandListsMode: {
                type: 'string',
                enum: ['never', 'always', 'single-legislation'],
                default: 'single-legislation',
            },
            autoExpandSubstancesMode: {
                type: 'string',
                enum: ['never', 'always', 'single-legislation'],
                default: 'single-legislation',
            },
            autoExpandListWhenOnlyOne: { type: 'boolean', default: true },
            includeListIdsMode: {
                type: 'string',
                enum: ['request-legislation-lists', 'emitted-list-ids'],
                default: 'request-legislation-lists',
            },
            referenceTitleMode: {
                type: 'string',
                enum: ['path-prefix', 'root-badges'],
                default: 'path-prefix',
            },
        },
    },
    settingsUi: {
        showQuestions: { control: 'switch' },
        showInstruction: { control: 'switch' },
        showSubstanceListInstruction: { control: 'switch' },
        showNoSinglePartsCheckbox: { control: 'switch' },
        showInformationOwnerSettings: { control: 'switch' },
        companyHasInformation: { control: 'switch' },
        autoExpandListsMode: { control: 'select' },
        autoExpandSubstancesMode: { control: 'select' },
        autoExpandListWhenOnlyOne: { control: 'switch' },
        includeListIdsMode: { control: 'select' },
        referenceTitleMode: { control: 'select' },
    },
})

export { concernSubstanceListsDescriptor }
export default concernSubstanceListsDescriptor
